import { render } from "./Team.vue?vue&type=template&id=5187577c&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=5187577c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5187577c"]])

export default __exports__